type Attribute = {
  id?: number;
  name: string;
  value: string;
};

export const decodeBase64ToUtf16 = (encodedString: string): string => {
  const binaryString = window.atob(encodedString);
  const utf16Bytes = new Uint8Array(binaryString.length);

  for (let position = 0; position < binaryString.length; position++) {
    utf16Bytes[position] = binaryString.charCodeAt(position);
  }

  const utf16Decoder = new TextDecoder("utf-16be");
  return utf16Decoder.decode(utf16Bytes);
};

const extractAttributesBase64 = (urlOrString: string): string | null => {
  try {
    const urlObject = new URL(urlOrString);
    return urlObject.searchParams.get("attributes");
  } catch {
    const splitResult = urlOrString?.split(";?attributes=");
    return splitResult?.[1] ?? null;
  }
};

export const deserializeAttributes = (urlOrString: string): Attribute[] => {
  const base64EncodedAttributes = extractAttributesBase64(urlOrString);

  if (!base64EncodedAttributes) {
    return [];
  }

  try {
    const decodedAttributesJson = decodeBase64ToUtf16(base64EncodedAttributes);
    return JSON.parse(decodedAttributesJson) as Attribute[];
  } catch {
    return [];
  }
};

export const checkAttributeMatch = (
  urlOrString: string,
  targetName: string,
  targetValue: string
): boolean => {
  const attributesList = deserializeAttributes(urlOrString);
  return attributesList.some(
    (attribute) =>
      attribute.name === targetName && attribute.value === targetValue
  );
};
